

export const AIGC_PROXY_HOST = 'https://cybersay.mossyu.com';
//export const AIGC_PROXY_HOST = 'http://localhost:8080';

/**
 * @brief Defining RTC & AIGC config
 * @notes If you wanna get full config and description of params, refer to https://api.volcengine.com/api-explorer?action=StartVoiceChat&groupName=%E6%99%BA%E8%83%BD%E4%BD%93&serviceCode=rtc&version=2024-06-01
 */
export class Config {

  //流式语音识别相关配置
  //RTC的appid
  AppId = '6791a703c1cde501dd2eb16c';

  //默认值为voiceChat_$(UserId)_$(timestamp_now)
  BotName = 'RTCBotTest';

  getAIGCConfig() {
    return {
      //你的音视频应用的唯一标志，参看获取 AppId
      AppId: this.AppId,

      //ASR、TTS 和 LLM 相关高级配置。
      Config: {
        // 流式语音识别相关配置。
        ASRConfig: {
          //语音识别服务提供商。支持取值及含义如下： volcano：火山引擎语音识别。
          Provider: "volcano",
          ProviderParams: {
            //模型类型。使用流式语音识别服务时取值为smallmodel，使用流式语音识别大模型服务时取值为bigmodel。
            Mode: "smallmodel",
            //已开通流式语音识别服务的 AppId。
            AppId: '8974420009'
          },

          VADConfig: {
            //判停时间。停顿时间若高于该值设定时间，则认为一句话结束。
            // 单位为 ms，默认值为 600。
            SilenceTime: 2500,
            //是否开启智能语义断句：
            // true：开启。启用后系统会结合 AI 模型对语义完整性的判断和 SilenceTime 来进行断句，能更准确地处理长句中的自然停顿，有效避免将一句话错误切分。
            AIVAD: true
          },

          //音量增益值。降低采集音量，以减少噪音引起的 ASR 错误识别。
          // 默认值为 1.0，推荐值 0.3。
          VolumeGain: 0.4
        },

        //语音合成相关配置。
        TTSConfig: {
          //语音合成服务提供商，支持取值及含义如下：volcano：火山引擎单向流式语音合成。volcano_bidirection：火山引擎双向流式语音合成（推荐）。minimax：MiniMax。
          Provider: "volcano",
          ProviderParams: {
            //火山语音技术应用配置。
            App: {
              //已开通需要的语音合成服务的 AppId。
              appid: '8974420009',
              //具体语音合成服务对应的 Cluster ID。大模型音频生成-大模型语音合成服务：volcano_tts；
              cluster: 'volcano_tts'
            },
            //火山语音技术音频配置。
            audio: {
              //具体语音合成服务开通音色 ID。
              voice_type: "BV701_streaming",
              //语速。语音合成服务：取值范围为[0.2,3]，默认值为 1.0，大模型声音复刻服务：取值范围为[0.8,2]，默认值为 1.0，
              speed_ratio: 0.9
            },
          },
        },

        //大模型相关配置，不同的大模型该参数结构不同：
        LLMConfig: {
          //大模型名称。
          // 方舟大模型： ArkV3。
          //第三方大模型：CustomLLM
          //CozeBot
          Mode: "CozeBot",
          CozeBotConfig:{
            //请求地址。该参数固定取值：https://api.coze.cn
            Url: "https://api.coze.cn",
            //Coze 智能体 ID。
            //https://www.coze.cn/space/7442348576392708148/bot/7442569016478433314
            BotId: "7574748506569900067",
            //https://www.coze.cn/open/docs/developer_guides/oauth_apps
            //APIKey: "sat_VXKOWs806SRQekxaF0wKob9743BBAIdvhDvqJTf9ZloSw2P4nr0kDMrJHmUzOYrE",
            APIKey: "sat_x3CPIYdDOliOiU7QN8KOzog5O19NqipBjvHecblkf9LMXJc5CWuZ0k8KjK4To8x8",
            HistoryLength: 5,
            //是否将上下文存储在 Coze 平台。
            EnableConversation: true,
            //用户参数
            Parameters: { "expert": "1"},
            //CustomVariables
            //为 Coze 智能体 Prompt 中定义的变量 {{key}} 动态赋值。Map<String, String> 格式，支持 Jinja2 语法。
            // CustomVariables: { "expert": "1", "custom_var_2": "value2" }
          },
        },

        //打断模式。支持取值及含义如下：0：语音自动打断；1：禁用语音打断。
        InterruptMode: 0,
      },

      //智能体基本配置。
      AgentConfig: {
        //智能体启动后的欢迎词。
        WelcomeMessage: '你好，欢迎来到我的咨询室。我是儒道哲学咨询智能体 — 赛博子曰，我精通孔子和老子的哲学思想，擅长帮助人们解决思想和观念上的困惑。我的方法是通过引导深入哲学思考，帮助你找到自己的答案。',
        //房间内智能体名称。赋值规则参看参数赋值规范。
        UserId: this.BotName,
      },
    };
  }
}

const config = new Config();

export * from './config';
export default config;
